import React from "react";

export default function StatCard({ label, value, hint, accent, icon: Icon, testid }) {
  return (
    <div
      className="bg-white border border-[#1F1E1B] p-5 card-hover"
      data-testid={testid}
    >
      <div className="flex items-start justify-between">
        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#66645E]">
          {label}
        </div>
        {Icon && (
          <div className={`w-8 h-8 flex items-center justify-center ${accent || "bg-[#1F1E1B]"}`}>
            <Icon className="w-4 h-4 text-white" strokeWidth={2.4} />
          </div>
        )}
      </div>
      <div className="font-display text-3xl font-black text-[#1F1E1B] mt-3 tabular">
        {value}
      </div>
      {hint && (
        <div className="text-xs text-[#66645E] mt-1.5">{hint}</div>
      )}
    </div>
  );
}
